import PersianaContainer from './containers/persiana-container';
export default PersianaContainer;